export default __webpack_public_path__ + "static/media/ChainSafe_Logo_text_right.5a9992f4.png";